import React from 'react';
import ReactDOM from 'react-dom';
import SplashverseOnboarding from '../routes/splashverse-onboarding';
import '../../css/dist/splashverse-onboarding-loggedout.scss';
import { Provider } from 'react-redux';
import { createReduxStore } from '../stores/splashverse-onboarding/store';

const App = () => {
  return (
    <Provider store={createReduxStore}>
      <SplashverseOnboarding/>
    </Provider>
  )
}

ReactDOM.render(
  <App/>, document.getElementById("child-onboard")
);
